<template>
  <div class="banner banner-welcome">
    <div class="d-flex flex-column justify-content-between align-items-start">
      <div class="bonus-name">
        <svg-icon icon="banners/badge" class="d-flex"/>
        <span>{{$t('bonus.welcome.name')}}</span>
      </div>
      <div class="d-flex flex-column gap-xs">
        <span class="bonus-description">{{$t('bonus.welcome.description')}}</span>
        <div class="d-flex flex-row gap-xs">
          <img src="/img/coins/gold_coin.svg">
          <span class="bonus-amount">{{ numberFormatter.formatNumber(config.sum.amount)}}</span>
        </div>
      </div>
      <div>
        <button type="button" @click.prevent="signUp"  class="btn btn-primary">{{ $t('sign_up') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SvgIcon from "@/components/SvgIcon.vue";
import {numberFormatter} from "@/service/NumberFormatter";
import WelcomeConfigDTO from "@/models/banners/WelcomeConfigDTO";
import {useRouter} from "vue-router";

const props = defineProps<{
  config: WelcomeConfigDTO
}>()

const router = useRouter();

const signUp = () => {
  router.push({name: 'login'})
}
</script>